export default {
  external: {
    pullRequestsListEmptyStateLearnHow:
      'https://confluence.atlassian.com/x/cRNODQ',
  },
};
